import React from "react";
import { useExternalLink } from "../context/ExternalLinkContext";

// Renders plain text with clickable external links (confirmed via ExternalLinkProvider)
// and, when onTag is provided, tappable #hashtags. Preserves surrounding text/whitespace.
const TOKEN_RE = /((?:https?:\/\/|www\.)[^\s]+|#[\p{L}\p{N}_]+)/giu;

export const RichText = ({ text, onTag, linkClassName }) => {
  const { openExternal } = useExternalLink();
  if (!text && text !== 0) return null;
  const parts = String(text).split(TOKEN_RE);
  return parts.map((part, i) => {
    if (!part) return null;
    if (/^(https?:\/\/|www\.)/i.test(part)) {
      const m = part.match(/[.,!?;:)\]}'"]+$/);
      const trail = m ? m[0] : "";
      const url = trail ? part.slice(0, part.length - trail.length) : part;
      const href = /^www\./i.test(url) ? `https://${url}` : url;
      return (
        <React.Fragment key={i}>
          <a
            href={href}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); openExternal(href); }}
            data-testid="external-link"
            className={linkClassName || "text-[#14A89A] underline decoration-1 underline-offset-2 hover:text-[#2BC4B5] break-all"}
          >{url}</a>{trail}
        </React.Fragment>
      );
    }
    if (onTag && /^#[\p{L}\p{N}_]+$/u.test(part)) {
      return (
        <button key={i} onClick={(e) => { e.stopPropagation(); onTag(part.toLowerCase()); }} data-testid={`hashtag-${part.slice(1).toLowerCase()}`} className="text-[#14A89A] hover:text-[#2BC4B5] transition-colors">{part}</button>
      );
    }
    return <span key={i} className="[overflow-wrap:anywhere]">{part}</span>;
  });
};
